<template>
	<div class="box-cls">
		<All v-if="formInfo.paperShowType == 2" :formData="formData" :realResultList="realResultList" @updateResult="updateResult" />
		<Single v-else :formData="formData" :realResultList="realResultList" @updateResult="updateResult" />
	</div>
</template>

<script>
import All from './All';
import Single from './Single';
export default {
	name: 'SurveyDesignPreview',
	props: ['formData', 'realResultList'],
	components: {All, Single},
	computed: {
		formInfo() {
			return this.formData.formInfo;
		},
	},
	methods: {
		updateResult(data) {
			this.$emit('updateResult',data)
		}
	},
}
</script>

<style lang="scss" scoped>
.box-cls {
	width: 100%;
	height: calc(100vh - 100px);
	overflow-x: hidden;
	overflow-y: auto;
}
</style>

